var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.00002C10.1217 5.00002 12.1566 5.84288 13.6569 7.34317C15.1571 8.84346 16 10.8783 16 13C16 15.1218 15.1571 17.1566 13.6569 18.6569C12.1566 20.1572 10.1217 21 8 21C5.87827 21 3.84344 20.1572 2.34315 18.6569C0.842855 17.1566 0 15.1218 0 13C0 10.8783 0.842855 8.84346 2.34315 7.34317C3.84344 5.84288 5.87827 5.00002 8 5.00002ZM8 7.00002C6.4087 7.00002 4.88258 7.63216 3.75736 8.75738C2.63214 9.8826 2 11.4087 2 13C2 14.5913 2.63214 16.1174 3.75736 17.2427C4.88258 18.3679 6.4087 19 8 19C9.5913 19 11.1174 18.3679 12.2426 17.2427C13.3679 16.1174 14 14.5913 14 13C14 11.4087 13.3679 9.8826 12.2426 8.75738C11.1174 7.63216 9.5913 7.00002 8 7.00002ZM8 8.50002L9.323 11.18L12.28 11.61L10.14 13.695L10.645 16.641L8 15.25L5.355 16.64L5.86 13.695L3.72 11.609L6.677 11.179L8 8.50002ZM14 2.34842e-05V3.00002L12.637 4.13802C11.5059 3.54461 10.2711 3.17486 9 3.04902V2.34842e-05H14ZM7 -0.000976562V3.04902C5.72935 3.17467 4.49482 3.54408 3.364 4.13702L2 3.00002V2.34842e-05L7 -0.000976562Z",
    fill: "#FFD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.1cc91045b7af749867099c3412174c8c.svg";
export { ForwardRef as ReactComponent };